

export const getDate = () => {
    const now = new Date();
    const formattedDate = formatDate(now);

    return formattedDate;
}

const formatDate = (date: Date) => {
    // Get individual components of the date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Return the formatted date string YYYY-MM-dd hh:mm:ss
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export const STATUS_COLORS: Record<string, { bg: string; color: string; border: string }> = {
    Unpicked: { bg: "rgba(255, 59, 48, 0.10)", color: "#FE0909", border: "none" },
    Unpacked: { bg: "rgba(74, 85, 101, 0.10)", color: "#61708A", border: "none" },
    Packed: { bg: "rgba(138, 43, 226, 0.10)", color: "#8A2BE2", border: "none" },
    Assigned: { bg: "rgba(255, 149, 0, 0.10)", color: "#F39600", border: "1px solid rgba(74, 85, 101, 0.10)" },
    Received: { bg: "rgba(0, 178, 33, 0.10)", color: "#00B221", border: "none" },
    Dispatched: { bg: "rgba(255, 149, 0, 0.10)", color: "#F39600", border: "1px solid rgba(74, 85, 101, 0.10)" },
    Out_for_delivery: { bg: "rgba(0, 94, 255, 0.10)", color: "#005EFF", border: "none" },
    Delivered: { bg: "rgba(52, 199, 89, 0.10)", color: "#00B221", border: "none" },
    Delayed: { bg: "rgba(255, 59, 48, 0.10)", color: "#FE0909", border: "1px solid rgba(255, 59, 48, 0.10)" },
};

export const getOrderStatusStyle = (status: string) => {
    return STATUS_COLORS[status] || { bg: "rgba(74, 85, 101, 0.10)", color: "#61708A", border: "none" };
};

export const formatOrderStatus = (status: string): string => {
    return status.replace(/_/g, " ");
}

export const formatDisplayDate = (dateStr: string): string => {
    return dateStr ? dateStr.split("T")[0] : "";
}